import { Button } from "@/components/ui/button";
import { Link2Off } from "lucide-react";
import { Link } from "react-router";

export default function ExpiredVouchLink() {
  return (
    <section className="hero">
      <div
        className="mx-auto flex w-full max-w-4xl  
        flex-col items-center gap-6 p-5 text-center "
      >
        <div className="flex size-16 items-center justify-center rounded-full bg-[#f6f7fb]">
          <Link2Off color="#8e9097" />
        </div>
        <div className="flex flex-col gap-2">
          <h2 className="text-3xl font-normal">Link expired</h2>
          <p className="text-base text-muted-foreground">
            It may have already been used. Ask the person who sent it for a new one.
          </p>
        </div>

        <Button
          size="xl"
          asChild
          className="w-full sm:w-fit"
        >
          <Link to="/" replace>
            See how Sakeena works
          </Link>
        </Button>
      </div>
    </section>
  );
}
